require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-indiana-latino-leadership-circle.json") })
        }
      }, "path---es-articles-tags-indiana-latino-leadership-circle");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-indiana-latino-leadership-circle!./.cache/json/es-articles-tags-indiana-latino-leadership-circle.json
// module id = 2358
// module chunks = 231608221292675